<nav class="navbar navbar-expand-md fixed-top navbar-dark flex-fill">
  <div class="navbar-header pl-2 pr-2 ml-3 text-center">
    <a class="navbar-brand m-0 w-100" href="#">
      <img src="./assets/img/logo.png" alt="lightning logo" width="35px" />
      <span class="ml-1">Gestion Taxi</span>
    </a>
  </div>
  <div class="sidebar-toggler ml-auto mr-3">
    <ul class="navbar-nav ml-auto mr-3">
      <li class="nav-item">
        <a class="btn nav-link" (click)="toggleSidebar()" pTooltip="Menú" tooltipPosition="bottom">
          <i class="pi pi-bars"></i>
        </a>
      </li>
    </ul>
  </div>
  <div class="nav-toggler-right mr-4 d-md-none">
    <button
      class=""
      type="button"
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseBasic"
    >
      <img src="./assets/img/user.jpg" class="img-fluid" alt="" />
    </button>
    <span class="user-profile nav-alert bg-danger"></span>
  </div>
  <ul class="navbar-nav flex-fill mt-1 align-items-center left-nav">
    <li class="nav-item navicon">
      <a class="btn nav-link" (click)="toggleSidebarPin()"
        ><i class="pi pi-bars"></i
      ></a>
    </li>
  </ul>

  <div
    class="collapse navbar-collapse right-nav"
    id="collapseBasic"
    [ngbCollapse]="isCollapsed"
  >
    <ul class="navbar-nav">
      <li class="nav-item" *ngIf="isStoreAdmin">
        <a
          class="btn nav-link position-relative"
          routerLink="/admin/food-orders"
          pTooltip="Pedidos"
          tooltipPosition="bottom"
        >
          <i class="pi pi-bell"></i>
          <p-badge
            *ngIf="unreadOrderCount > 0"
            [value]="unreadOrderCount.toString()"
            severity="danger"
            styleClass="position-absolute top-0 start-75"
          ></p-badge>
        </a>
      </li>
      <li class="nav-item">
        <a class="btn nav-link" (click)="logout()" pTooltip="Salir" tooltipPosition="bottom">
          <i class="pi pi-sign-out"></i>
          <span class="link-text">Salir</span>
        </a>
      </li>
    </ul>
  </div>
</nav>
